
export const initialNedocs = { pristine: true };

export function nedocsReducer(state = initialNedocs, action = undefined) {
  switch (action.type) {
    case "NEDOCS_REQUEST":
      return {
        ...state,
        pristine: false,
        loading: true,
      };
    case "NEDOCS_SUCCESS":
      return {
        ...state,
        loading: false,
        nedocs: action.nedocsStatus,
      };
    case "NEDOCS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}